import React from 'react';
import { formatText, FormattedText } from 'core/i18n';

export const ModalWithImageContent = ({ image, title, subtitle }) => (
    <>
        <div className="upload-documentation-modal-image">
            <img src={image} alt="" />
        </div>
        <div className="upload-documentation-modal-title">
            <p>{formatText(title)}</p>
        </div>
        <div className="upload-documentation-modal-subtitle">
            <p>
                <FormattedText value={subtitle} />
            </p>
        </div>
    </>
);
